import {FC, memo} from "react";
import {SectionVariantsOptionProps} from "./SectionVariantsOption-types";
import {IconLetter, IconSelected, IconSelectedWrap, Image, Root} from "./SectionVariantsOption-styles";
import {useOptionAttributeDisabled, useOptionAttributeSelected} from "./SectionVariantsOption-hooks";


const SectionVariantsOption: FC<SectionVariantsOptionProps> = memo((props) => {
    const {uid, option, onClick} = props;

    const isDisabled = useOptionAttributeDisabled(option);
    const isSelected = useOptionAttributeSelected(uid, option);

    return (
        <Root
            title={option.title}
            $isDisabled={isDisabled}
            onClick={isDisabled ? undefined : () => onClick(uid, option)}>

            <Image $background={option.imagePreview}/>

            {
                isSelected &&
                <IconSelectedWrap>
                    <IconSelected/>
                </IconSelectedWrap>
            }

            {
                option.filters?.includes('has-text') &&
                <IconLetter>А</IconLetter>
            }
        </Root>
    )
});

export default SectionVariantsOption;
